export default __webpack_public_path__ + "static/icon-10-2-65438ad3115c1ef1f404074284bdf8cc.png";